import React from "react";
import './DownloadCV.css'
import CV from './MyResume.pdf'

const DownloadCV = () => {
  return (
    <>
    <div className="cv">
      <a href={CV} download>
        <button className="download">Download CV</button>
      </a>
    </div></>
    
  );
};

export default DownloadCV;
